import { render, staticRenderFns } from "./appCardDirect.vue?vue&type=template&id=cf45a20e&scoped=true"
import script from "./appCardDirect.vue?vue&type=script&lang=js"
export * from "./appCardDirect.vue?vue&type=script&lang=js"
import style0 from "./appCardDirect.vue?vue&type=style&index=0&id=cf45a20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf45a20e",
  null
  
)

export default component.exports